/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type HookTuple = [
  response: vp.InteracBulkPayoutTransactionResponse,
  fetchData: (transactionID: string) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchInteracBulkPayoutTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<string>();
  const [response, setResponse] = useState<vp.InteracBulkPayoutTransactionResponse>({
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.BLANK,
    FailureReason: '',
    TransactionDateTime: '',
    Amount: '',
    Currency: 'CAD',
    HoldAmount: '',
    LastModified: '',
    SenderName: '',
    RecipientName: '',
    EmailAddress: '',
    PhoneNumber: '',
    Memo: '',
    ClientReferenceNumber: '',
    ConfirmationNumber: '',
    ProcessingDate: '',
    CancellationPeriod: '',
    Name: '',
    Notes: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: string) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen', true);

      const res = await api.fetchInteracBulkPayoutTransaction({ TransactionID: requestParams }, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'loading some data', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: string) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.BLANK,
        FailureReason: '',
        TransactionDateTime: '',
        Amount: '',
        Currency: 'CAD',
        HoldAmount: '',
        LastModified: '',
        SenderName: '',
        RecipientName: '',
        EmailAddress: '',
        PhoneNumber: '',
        Memo: '',
        ClientReferenceNumber: '',
        ConfirmationNumber: '',
        ProcessingDate: '',
        CancellationPeriod: '',
        Name: '',
        Notes: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchInteracBulkPayoutTransaction);
